// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1rozs","log":"ModalInventoryLogs_log__3t7cG","date":"ModalInventoryLogs_date__1h4Xn","userName":"ModalInventoryLogs_userName__1jkWu"};